import { render, staticRenderFns } from "./CreateAssignment.vue?vue&type=template&id=4d53fb7a&"
import script from "./CreateAssignment.vue?vue&type=script&lang=js&"
export * from "./CreateAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports